<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'calculate-savings',
          title: 'Calculate savings',
          active: 1,
          image: '',
          color: 'white',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: 'ri:bank-line',
          icon_color: 'revinre',
          h2: 'Calculate your savings',
          h2_color: '',
          h2_desc: 'Use the slider below to calculator how much you can save by listing your property with us. This calculation is based on the typical 3% listing commission compared to 0% listing commission with us.',
          h2_desc_color: '',

          cal_bg_color: '',
          slider: 'Property value',
          slider_color: 'black',
          min_value: 100000,
          min_value_color: 'gray-700',
          default_value: 500000,
          default_value_color: 'success',
          max_value: 2000000,
          max_value_color: 'gray-700',
          savings: 'Your estimated savings',
          savings_color: 'black',
          estimated_color: 'success',
          total_sales: 'Total sales',
          total_sales_color: 'gray-700',
          total_sales_value_color: 'black',
          total_savings: 'Total savings',
          total_savings_color: 'gray-700',
          total_savings_value_color: 'black',
          average_savings: 'Average savings',
          average_savings_color: 'gray-700',
          average_savings_value_color: 'black',
          btn_color: 'revinre',
          btn_pre_icon: 'ri:arrow-right-line',
          btn_text: 'Get started',
          btn_post_icon: '',
          btn_url: '/selling',
          image_url: '/fm/revinre/clip art/Comparative market analysis.png',
          image_alt: 'Calculate your savings',
        },

        loading_totals: true,
        totals: {
          total_sales: 0,
          total_savings: 0,
          average_savings: 0,
        },

        value: 5000000,
        options: {
          min: 1000000,
          max: 20000000,
          interval: 50000,
          height: 5,
          dotSize: 20,
          show: true,
          tooltip: 'none',
          formatter: function (value) {
            return this.formatPrice(value);
          },
          railStyle: {
            "backgroundColor": "#ffbd00"
          },
          sliderStyle: {
            "backgroundColor": "#ffbd00"
          },
          processStyle: {
            "backgroundColor": "#ffbd00"
          },
        }
      }
    },
    computed: {
      estimatedSavings: function() {
        let total = (3 / 100) * parseInt(this.value);
        total = total.toFixed(0);
        if(total < 0) {
          return 0;
        } else {
          return total;
        }
      },
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(this.pc['default_value']) { this.value = parseInt(this.pc['default_value']); }
      if(this.pc['min_value']) { this.options.min = parseInt(this.pc['min_value']); }
      if(this.pc['max_value']) { this.options.max = parseInt(this.pc['max_value']); }
      if(this.type != 'editor') { this.fetch_totals(); }
    },
    methods: {
      fetch_totals() {
        this.loading_totals = true;
        this.$http.get((this.isAdmin ? '/api' : '')+'/listings/fetch-savings').then(res => {
          // console.log(res);
          this.totals = res.data;
          this.loading_totals = false;
        }).catch(res => {
          this.loading_totals = false;
          // this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
        });
      },
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Savings calculator :</h6>
        <div class="row">
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.cal_bg_color" Title="Background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.slider" Title="Slider text :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.slider_color" Title="Slider text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" Min="0" Max="100000000" v-model="pc.min_value" Title="Min value :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.min_value_color" Title="Min value color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" Min="0" Max="100000000" v-model="pc.default_value" Title="Default value :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.default_value_color" Title="Default value color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" Min="0" Max="100000000" v-model="pc.max_value" Title="Max value :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.max_value_color" Title="Max value color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.savings" Title="Savings text :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.savings_color" Title="Savings text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.estimated_color" Title="Estimated savings text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.total_sales" Title="Total sales text :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.total_sales_color" Title="Total sales text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.total_sales_value_color" Title="Total sales value color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.total_savings" Title="Total savings text :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.total_savings_color" Title="Total savings text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.total_savings_value_color" Title="Total savings value color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.average_savings" Title="Average savings text :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.average_savings_color" Title="Average savings text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.average_savings_value_color" Title="Average savings value color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.btn_color" Title="Button color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.btn_pre_icon" Title="Pre button icon :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.btn_text" Title="Button text :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.btn_post_icon" Title="Post button icon :"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String" v-model="pc.btn_url" Title="Button URL :"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Side image :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image_url" Title="Image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image_alt" Title="Image alt text :"></w-field>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div class="row justify-content-center">
          <div class="col-sm-5">
            <div class="card _b-r-10 _box-shadow-0-1-10-b-2" :class="'bg-'+pc['cal_bg_color']">
              <div class="card-body p-5">
                <div class="font-weight-bold" :class="'text-'+pc['slider_color']">{{pc['slider']}}</div>
                <vue-slider class="mb-1" ref="slider" v-model="value" v-bind="options"></vue-slider>
                <div class="row m-0 mb-4">
                  <div class="col-4 p-0" :class="'text-'+pc['min_value_color']">{{formatPrice(options.min, true, false)}}</div>
                  <div class="col-4 p-0 text-center font-weight-bold" :class="'text-'+pc['default_value_color']">{{formatPrice(value, true, false)}}</div>
                  <div class="col-4 p-0 text-right" :class="'text-'+pc['max_value_color']">{{formatPrice(options.max, true, false)}}</div>
                </div>
                <div class="font-weight-bold" :class="'text-'+pc['savings_color']">{{pc['savings']}}</div>
                <p class="mb-3 font-weight-bold _f-s-35" :class="'text-'+pc['estimated_color']">$ <span class="_f-s-55 align-middle">{{formatPrice(estimatedSavings, false, false)}}</span></p>
                <div class="row m-0 pt-4 border-top border-fade-d-01">
                  <div class="col-sm-4 p-0" v-tippy :content="'The total value of all homes sold with '+app_name+'.'">
                    <div :class="'text-'+pc['total_sales_color']">{{pc['total_sales']}}</div>
                    <div v-if="loading_totals" class="ph mr-2" style="height: 27px;"></div>
                    <p v-else class="m-0 font-weight-bold" :class="'text-'+pc['total_sales_value_color']">{{formatPrice(totals.total_sales, true, false)}}</p>
                  </div>
                  <div class="col-sm-4 p-0" v-tippy :content="'The total savings with '+app_name+' so far.'">
                    <div :class="'text-'+pc['total_savings_color']">{{pc['total_savings']}}</div>
                    <div v-if="loading_totals" class="ph mr-2" style="height: 27px;"></div>
                    <p v-else class="m-0 font-weight-bold" :class="'text-'+pc['total_savings_value_color']">{{formatPrice(totals.total_savings, true, false)}}</p>
                  </div>
                  <div class="col-sm-4 p-0" v-tippy :content="'The average savings per client with '+app_name+' so far.'">
                    <div :class="'text-'+pc['average_savings_color']">{{pc['average_savings']}}</div>
                    <div v-if="loading_totals" class="ph mr-2" style="height: 27px;"></div>
                    <p v-else class="m-0 font-weight-bold" :class="'text-'+pc['average_savings_value_color']">{{formatPrice(totals.average_savings, true, false)}}</p>
                  </div>
                </div>
                <a class="btn btn-block btn-lg d-inline-block _box-shadow-0-1-4-b-2 _b-r-10 _m-b-n-110" :class="'btn-'+pc['btn_color']" :href="pc['btn_url']">
                  <Icon v-if="pc['btn_pre_icon']" :icon="pc['btn_pre_icon']" height="20"></Icon>
                  <span v-if="pc['btn_pre_icon'] && pc['btn_text']" class="border-left mx-3"></span>
                  {{ pc['btn_text'] }}
                  <span v-if="pc['btn_post_icon'] && pc['btn_text']" class="border-left mx-3"></span>
                  <Icon v-if="pc['btn_post_icon']" :icon="pc['btn_post_icon']" height="20"></Icon>
                </a>
              </div>
            </div>
          </div>
          <div class="col-sm-5 offset-sm-1">
            <div data-aos="fade-zoom-in"><img :src="formatImage(pc['image_url'])" :alt="pc['image_alt']" class="img-fluid mx-auto d-block"></div>
          </div>
        </div>

      </div>
    </div>
  </section>

</template>
